var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SearchComponent',{attrs:{"category":_vm.category,"subcategory":_vm.subcategory}})}
var staticRenderFns = []

export { render, staticRenderFns }